import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import OrderVpsUsComponent from "../../../components/Customer/cards/OrderVpsUsComponent";

const OrderVpsUsPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate(-1);
    }

    let redirect = (orderId) => {
        navigate('/don-dat-hang/' + orderId + '/chi-tiet-don-dat-hang.html');
    }

    return <OrderVpsUsComponent
        productId={ params.productId }
        billcycle={ params.billcycle }
        shouldRedirect={ (orderId) => redirect(orderId) }
        redirectBack={ () => redirectBack() }
    />;
}

export default OrderVpsUsPage;